module.exports = __webpack_public_path__ + "img/giving-title.745d05ff.png";